module.exports = __webpack_public_path__ + "static/media/sage_and_sky_header.9163a911.png";